import React from 'react'
import { createRoot } from 'react-dom/client'
import 'leaflet/dist/leaflet.css'
import '@scuf/common/honeywell-compact-dark/theme.css'
import '@scuf/datatable/honeywell-compact-dark/theme.css'
import '@scuf/charts/honeywell-compact-dark/theme.css'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { oidcConfig } from './forgeiam/authConfig'
import { AuthProvider } from 'react-oidc-context'

const container = document.getElementById('root')

if (container !== null) {
  const root = createRoot(container)
  root.render(
    <Provider store={store}>
        <AuthProvider {...oidcConfig}>
            <App/>
        </AuthProvider>
    </Provider>
  )
}
document.title = window._env_.REACT_APP_APPLICATION_TITLE ?? ''
reportWebVitals()
